<script setup lang="ts">
import { FetchError } from 'ofetch';

const email = ref<string>('');
const validation = ref<SendEmailRequestValidation>();
const isEmailValid = computed(
  () =>
    validation.value &&
    !validation.value?.error?.issues.find((e) => e.path[0] === 'email')
);

const validate = () => {
  validation.value = SendEmailRequestSchema.safeParse({ email: email.value });
  return validation.value;
};

const revalidate = () => {
  if (validation.value === undefined) {
    return;
  }
  validate();
};

const loading = ref<boolean>(false);
const error = ref<string>('');
const emailSent = ref<boolean>(false);

const submit = async () => {
  const validation = validate();
  if (!validation.success) {
    return;
  }

  error.value = '';
  loading.value = true;
  try {
    await $fetch('/api/token/send', {
      method: 'POST',
      body: validation.data
    });
    emailSent.value = true;
  } catch (err) {
    error.value = `エラーが発生しました: ${err instanceof FetchError ? err.data?.message : `${err}`}.`;
  }
  loading.value = false;
};
</script>

<template>
  <Loading v-if="loading" />
  <div v-else class="mt-3 d-flex flex-column align-items-center p-1">
    <div style="height: 3em;">
      <img class="h-100 w-auto" src="~/assets/logo.png" alt="京都大学医学部附属病院" />
    </div>

    <div v-if="emailSent" class="mt-4 w-100 alert alert-success text-center">
      メールを送信しました。メールをご確認ください。
    </div>

    <div v-else class="mt-4 w-100 d-flex flex-column align-items-center">
      <div class="w-100 alert alert-secondary text-center" role="alert">
        <h4>診療予約変更の申請</h4>
        <small>
          本院の既存のご予約の変更をご希望の場合は、まずメールアドレスを入力し、「送信」をクリックしてください。メールで申請を進めるためのリンクが届きます。
        </small>
      </div>

      <form class="mt-1 p-3 w-100 border rounded" @submit.prevent="submit" novalidate>
        <div>
          <label for="email" class="form-label">メールアドレス:</label>
          <input id="email" type="email"
                 :class="`form-control${isEmailValid === undefined ? '' : isEmailValid ? ' is-valid' : ' is-invalid'}`"
                 placeholder="kuhp@example.com" @blur="validate" @input="revalidate" v-model="email" />
        </div>

        <div class="mt-2 d-flex justify-content-center">
          <button type="submit" class="btn btn-outline-secondary" style="min-width: 8em;">
            <i class="bi bi-envelope" />
            <span class="ms-2">送信</span>
          </button>
        </div>

        <div v-if="error" class="alert alert-danger mt-2">
          {{ error }}
        </div>
      </form>
    </div>
  </div>
</template>